export default __webpack_public_path__ + "7f538623984d60fbe61c695123a86301.svg";